/**
 * Префикс всего, что модуль пишет в консоль.
 *
 * На странице платформы наш вывод соседствует с выводом СТАРОГО боевого тула
 * (`idea_calc`), который живёт там же. Общий префикс `[idea-calc]` сливал бы
 * две ленты в одну и делал разбор чужого бага нашим. Имя совпадает с именем
 * remote'а в контракте платформы — по нему строка однозначно наша.
 */
export const LOG_TAG = '[profitCalculator]';
